import styled from "@emotion/styled";

export default function ModalAdminfaqone({ onClose, history }) {
  const formattedDate = (date) => {
    const newDate = new Date(date);
    const formatted = newDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    return formatted;
  };

  return (
    <RootWrapperModalAdminfaqone>
      <Overlay>
        <Wrapper>
          <TermsAndCondtions>
            <Left>
              <Frame58>
                <Frame1391>
                  <UpdateHistory>History of Updates</UpdateHistory>
                  {history.length > 0 &&
                    history.map((val, idx) => (
                      <Frame1572>
                        <_9May2025>{formattedDate(val?.updated_at)}</_9May2025>
                        <QuestionHowDoesPaartnerWorkAnswerYouConfirmThatTheInformationYouVeProvidedIsAccurateTruthfulAndSubmittedWithTheKnowledgeOrConsentOfTheReferredPerson
                          style={{ fontWeight: 700 }}
                        >
                          Question : {val?.question}
                        </QuestionHowDoesPaartnerWorkAnswerYouConfirmThatTheInformationYouVeProvidedIsAccurateTruthfulAndSubmittedWithTheKnowledgeOrConsentOfTheReferredPerson>
                        <QuestionHowDoesPaartnerWorkAnswerYouConfirmThatTheInformationYouVeProvidedIsAccurateTruthfulAndSubmittedWithTheKnowledgeOrConsentOfTheReferredPerson>
                          Answer: {val?.answer}
                        </QuestionHowDoesPaartnerWorkAnswerYouConfirmThatTheInformationYouVeProvidedIsAccurateTruthfulAndSubmittedWithTheKnowledgeOrConsentOfTheReferredPerson>
                      </Frame1572>
                    ))}
                </Frame1391>
              </Frame58>
            </Left>
          </TermsAndCondtions>
        </Wrapper>
      </Overlay>
    </RootWrapperModalAdminfaqone>
  );
}

const RootWrapperModalAdminfaqone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;


const TermsAndCondtions = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const UpdateHistory = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1572 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _9May2025 = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const QuestionHowDoesPaartnerWorkAnswerYouConfirmThatTheInformationYouVeProvidedIsAccurateTruthfulAndSubmittedWithTheKnowledgeOrConsentOfTheReferredPerson = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

